import produce from 'immer'
import { StatisticState } from '../../model/statistic/types'
import {
    StatisticActionTypes,
    getDashboardStatisticActionType,
    getLiveStatisticActionType
} from '../../model/statistic/actions'

const initialState: StatisticState = {
    dashboard: undefined,
    live: undefined
}

export function statisticReducer(
    state = initialState,
    action: StatisticActionTypes
): StatisticState {
    switch (action.type) {
        case getDashboardStatisticActionType.success:
            return produce(state, draftState => {
                draftState.dashboard = action.payload
            })
        case getDashboardStatisticActionType.failure:
            return produce(state, draftState => {
                draftState.dashboard = undefined
            })
        case getLiveStatisticActionType.success:
            return produce(state, draftState => {
                draftState.live = action.payload
            })
        case getLiveStatisticActionType.failure:
            return produce(state, draftState => {
                draftState.live = undefined
            })
        default:
            return state
    }
}
